<template>
	<div>
		<div class="button-group has-text-centered mb40">
			<button v-for="type in types" class="button btn-transparent hvr-warning hvr-dashed is-size-6 has-text-primary has-text-weight-bold mr5 ml5 mb20" @click="changeType(type)" :class="[activeType==type ? 'is-checked' : '']">
				{{t(type.name)}}
			</button>
		</div>
		<div v-infinite-scroll="loadNextPage" infinite-scroll-disabled="busy" infinite-scroll-distance="8">
			<div v-masonry transition-duration="1s" item-selector=".item" :origin-left="sitelocale == 'ar' ? 'false' : 'true' " class="columns is-multiline">
				<div v-masonry-tile v-for="(element,index) in items" :class='[element.type]'  class="item column is-3  p5 card-with-hover-project" :key="index">
					<div class="hvr-grow w-100">
						<div class="radius-lg card-with-overlay card-grey">
							<a rel="noreferrer" :href="element.link" class="radius-lg-img is-overlay-hideen is-block position-relative ">
								<figure >
									<img class="image-cover card" :src="element.image ? element.image : 'https://via.placeholder.com/318x220'" >
								</figure>
								<div class="is-overlay">
									<p class="has-background-warning has-text-white overlay-title has-text-weight-bold">
										{{element.name}}
									</p>
								</div>
							</a>
						</div>
					</div>
				</div>
			</div>
			<div v-if="isLoading" class="loading-container has-text-centered pt200 pb200">
				<figure class="image is-128x128 image-contain mr-auto">
					<img src="/front/img/spinner.svg">
				</figure>
			</div>
			<div class="has-text-centered"  v-show="loadMore">
				<a rel="noreferrer" class="button is-primary hvr-shutter-out-vertical hvr-warning is-rounded p25 pr40 pl40" href="#">{{ t('load_more')}}</a>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios';
	import infiniteScroll from 'vue-infinite-scroll';
	import trans from "../translation/gallery.json";
	export default {
		name: 'Projects',
		directives: {
			infiniteScroll
		},
		props: {
			sitelocale: {
				type: String,
				required: true
			},
			url: String,
			types:{
				type:Array,
				required:true
			}
		},
		data() {
			return {
				items: [],
				order : [],
				loaded:false,
				currentPage: 0,
				fetching: false,
				nextUrl : String,
				loadMore : true,
				isActive: false,
				activeType:null,
				isLoading: false
			}
		},
		mounted() {
			this.$translate.setLang(this.sitelocale);

		},
		computed: {
			busy() {
				return this.fetching
			}
		},
		locales: trans,
		methods: {
			loadNextPage() {
				this.currentPage++;
				this.fetching = true;
				if(this.nextUrl != null){
					this.loaded =false;
					if(!this.nextUrl.includes('page')){
						this.isLoading = true;
					}
					else{
						this.isLoading = false;
					}
					axios.get(this.nextUrl).then(({ data }) => {
						this.items.push(...data.data);
						this.loaded =true;
						this.isLoading = false;
						if(data.links.next != null) {
							this.nextUrl = data.links.next;
						} else {
							this.nextUrl = data.links.next;
						}
						this.fetching = false;
					});
				}
				else{
					this.loadMore = false;
				}
			},
			changeType(type){
				this.activeType = type;
				this.items = [];
				this.nextUrl = type.url;
				this.loadNextPage();
			}
		},
		created() {
			this.activeType = this.types[0];
			this.nextUrl = this.activeType.url;
			this.items = [];
			this.loadNextPage();
			this.loaded =true;
		}
	};
</script>

<style lang="scss">

</style>


